/* Custom (Lamp Boy): relocate the hidden sale/custom badge (rendered by
   snippets/first-image-badge.liquid) onto the FIRST image of the currently
   selected variant in the product gallery. Re-runs on variant change so the
   badge follows the active variant's lead image. No-ops on any page without
   the gallery / badge source. */
(function () {
  function init() {
    var source = document.querySelector('[data-first-image-badge-source]');
    if (!source) return;

    var badge = source.querySelector('.product-badge-container-custom');
    // Bail if there are no actual badge chips (e.g. not on sale + no custom badge).
    if (!badge || !badge.querySelector('.product-badge-custom')) return;

    var root = document.querySelector('[data-product-root]') || document;
    var list = root.querySelector('.splide--product .splide__list');
    if (!list) return;

    badge.classList.add('first-image-badge');
    badge.setAttribute('data-first-image-badge', '');

    function firstImageWrapper() {
      var slides = list.querySelectorAll(':scope > li.splide__slide');
      var fallback = null;
      for (var i = 0; i < slides.length; i++) {
        var li = slides[i];
        if (li.classList.contains('splide__slide--clone')) continue;
        // Skip slides hidden for the non-active variant (single-variant mode).
        if (getComputedStyle(li).display === 'none') continue;
        var wrap = li.querySelector('[data-product-single-media-wrapper]');
        if (!wrap) continue;
        if (li.querySelector('[data-product-image-index]')) return wrap; // first image
        if (!fallback) fallback = wrap; // first visible media (e.g. video) as fallback
      }
      // Last resort: the very first media wrapper regardless of visibility.
      return fallback || list.querySelector('[data-product-single-media-wrapper]');
    }

    var scheduled = false;
    function place() {
      scheduled = false;
      var target = firstImageWrapper();
      if (!target) return;
      if (badge.parentElement !== target) target.appendChild(badge);
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      (window.requestAnimationFrame || window.setTimeout)(place);
    }

    place();

    // Variant change repaints the gallery (single-variant media groups) -> re-anchor.
    if (window.MutationObserver) {
      var mo = new MutationObserver(schedule);
      mo.observe(list, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
    }
    // Extra safety nets for variant / thumbnail interaction and layout shifts.
    ['theme:variant:change', 'variant:change', 'variant:changed'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(place, 60); setTimeout(place, 350); });
    });
    root.addEventListener('click', function () { setTimeout(place, 60); });
    root.addEventListener('change', function () { setTimeout(place, 60); });
    window.addEventListener('resize', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
